import { render, staticRenderFns, recyclableRender, components } from "./uni-transition.vue?vue&type=template&id=6369f8c4&"
var renderjs
import script from "./uni-transition.vue?vue&type=script&lang=js&"
export * from "./uni-transition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-transition/components/uni-transition/uni-transition.vue"
export default component.exports